// extracted by mini-css-extract-plugin
export default {"viber":"ViberGroup_viber__kP3zy","slideInFromRight":"ViberGroup_slideInFromRight__QcUP-","text":"ViberGroup_text__MzFAg","icon":"ViberGroup_icon__6YUU1"};